import styled from "styled-components";
import theme from "../../../utils/theme";
import BaseWrapper from "../../common/Wrapper";
import BaseButton from "../../common/Button";

export const Container = styled.div`
  padding-top: 5.8rem;
  background-color: ${theme.colors.white};
`;

export const Wrapper = styled(BaseWrapper)`
  max-width: 94rem;
`;

export const Hero = styled.div`
  margin-bottom: 4.8rem;
  text-align: center;

  ${theme.breakpoints.md`
    margin-bottom: 3rem;
  `}
`;

export const HeroLogo = styled.div`
  margin-bottom: 1.8rem;

  svg {
    width: 15.3rem;
    height: 2.6rem;
    margin: 0 auto;
    fill: ${theme.colors.suite[900]};
  }
`;

export const HeroTitle = styled.h1`
  font-weight: 500;
  font-size: 5.2rem;
  line-height: 5.8rem;
  margin-bottom: 0.9rem;
  color: ${theme.colors.suite[900]};

  ${theme.breakpoints.sm`
    font-size: 4rem;
    line-height: 5rem;
  `}
`;

export const HeroDescription = styled.p`
  font-size: 2rem;
  line-height: 2.8rem;
  margin-bottom: 2.1rem;
  color: ${theme.colors.gray[800]};
`;

export const AvailabilityDisclaimer = styled.p`
  margin: 1.6rem auto 0;
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${theme.colors.gray[800]};
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -0.2rem;
  z-index: 1;
`;

export const Action = styled.div`
  padding: 0.2rem;
`;

export const Preview = styled.div`
  margin: 4.8rem 0 5.1rem;
  text-align: center;
`;

export const ImageLayout = styled.div`
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  font-weight: 500;
  font-size: 3.6rem;
  line-height: 4.1rem;
  margin: 0 auto 4.3rem;
  text-align: center;
  color: ${theme.colors.suite[900]};

  ${theme.breakpoints.sm`
    font-size: 3rem;
    margin-bottom: 2rem;
  `}
`;

export const SectionSubTitle = styled.h3`
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 2.4rem;
  margin-bottom: 0.3rem;
  color: ${theme.colors.suite[900]};
`;

export const SectionIcon = styled.div`
  margin-bottom: 1rem;

  svg {
    width: 8.6rem;
    height: 8.6rem;
    margin: 0 auto;
  }
`;

export const SectionDescription = styled.p`
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${theme.colors.gray[800]};
`;

export const SectionNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 500;
  line-height: 1;
  width: 4.2rem;
  height: 4.2rem;
  border-radius: 50%;
  background-color: ${theme.colors.suite[900]};
  color: ${theme.colors.white};
`;

export const Grid = styled.div`
  display: flex;
  margin: -1rem;

  ${theme.breakpoints.md`
    flex-direction: column;
  `}
`;

export const Cell = styled.div`
  width: calc(100% / 3);
  padding: 1rem;

  ${theme.breakpoints.md`
    width: 100%;
  `}
`;

export const Card = styled.div`
  height: 100%;
  padding: 4rem;
  box-shadow: ${theme.shadows.raised};
  border-radius: 0.6rem;
  border: 0.1rem solid ${theme.colors.gray[500]};
  background-color: ${theme.colors.white};

  ${theme.breakpoints.lg`
    padding: 3rem 2rem 2rem;
  `}
`;

export const Button = styled(BaseButton)`
  display: flex;
  align-items: center;
  padding: 0.9rem 2.4rem;
  font-weight: 500;

  svg {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: 0.8rem;
  }
`;

export const ButtonTry = styled.a`
  ${theme.buttons.base}
  ${theme.buttons.variants.primary}
  ${theme.buttons.sizes.medium}
  margin-right: 8px;
`;

// Sections
export const Working = styled.div`
  margin: 5.1rem 0 7.9rem;
  text-align: center;

  ${theme.breakpoints.sm`
    margin: 4rem 0;
  `}

  ${SectionNumber} {
    margin: -4.2rem auto 0;
    transform: translateY(-2rem);
  }

  ${SectionTitle} {
    margin: 0 auto 6.8rem;

    ${theme.breakpoints.md`
      margin-bottom: 5rem;
    `}
  }

  ${SectionSubTitle} {
    font-size: 2.4rem;
    line-height: 4.1rem;
  }

  ${Card} {
    padding: 4rem 3rem 3rem;
  }

  ${Grid} {
    ${theme.breakpoints.md`
      margin: -2rem;
    `}
  }

  ${Cell} {
    ${theme.breakpoints.md`
      padding: 2rem;
    `}
  }
`;

export const Clients = styled.div`
  margin: 7.9rem 0 8.2rem;

  ${theme.breakpoints.sm`
    margin: 4rem 0;
  `}

  ${SectionTitle} {
    margin-bottom: 6.7rem;
  }
`;

export const Client = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 56rem;
  margin: 0 auto 7.3rem;

  ${theme.breakpoints.md`
    flex-direction: column;
  `}

  ${theme.breakpoints.sm`
    margin: 0 auto 4rem;
  `}

  &:last-child {
    margin-bottom: 0;

    ${theme.breakpoints.sm`
      margin: 0;
    `}
  }
`;

export const ClientDetails = styled.div`
  max-width: 50%;
`;

export const ClientIcon = styled.div`
  ${theme.breakpoints.md`
    margin-bottom: 2rem;
    order: -1;
  `}

  svg {
    width: 15.6rem;
  }
`;

export const GettingStarted = styled.div`
  padding: 8rem 0 4.9rem;
  background-color: #f9f9f9;

  ${theme.breakpoints.sm`
    padding: 4rem 0;
  `}

  ${SectionTitle} {
    margin-bottom: 8.1rem;

    ${theme.breakpoints.sm`
      margin-bottom: 5rem;
    `}
  }

  ${SectionNumber} {
    margin-top: -4.2rem;
    transform: translateY(-2rem);

    ${theme.breakpoints.lg`
      transform: translateY(-1rem);
    `}
  }

  ${Grid} {
    ${theme.breakpoints.md`
      margin: -2rem;
    `}
  }

  ${Cell} {
    ${theme.breakpoints.md`
      padding: 2rem;
    `}
  }
`;

export const GettingStartedFooter = styled.div`
  margin-top: 4rem;
  text-align: center;

  ${theme.breakpoints.sm`
    margin-top: 1rem;
  `}
`;

export const GettingStartedSubTitle = styled.h2`
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 4.1rem;
  margin-bottom: 1rem;
  color: ${theme.colors.suite[900]};
`;

export const GettingStartedList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0 0;
  padding: 0;
  list-style: none;
`;

export const GettingStartedListItem = styled.li`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  line-height: 1.8rem;
  margin: 1rem;
  color: ${theme.colors.gray[800]};

  svg {
    width: 1.1rem;
    height: 1.2rem;
    margin-right: 0.5rem;

    g {
      stroke: ${theme.colors.suite[900]};
    }
  }
`;
